export var SANDBOX_API_URL = 'https://api.dev.heydoctor.com/v1';
export var PRODUCTION_API_URL = 'https://api.heydoctor.com/v1';
export var SANDBOX_OAUTH_ORIGIN = 'https://app.dev.heydoctor.com';
export var PRODUCTION_OAUTH_ORIGIN = 'https://app.heydoctor.com';
export var Environments;
(function (Environments) {
    Environments["DEVELOPMENT"] = "development";
    Environments["SANDBOX"] = "sandbox";
    Environments["PRODUCTION"] = "production";
})(Environments || (Environments = {}));
export var Tasks = [
    {
        code: 'Consent',
        slug: 'getting-started',
    },
    {
        code: 'Questionnaire',
        slug: 'intake-interview',
    },
    {
        code: 'Photo',
        slug: 'photos',
    },
    {
        code: 'Phone',
        slug: 'consent-phone',
    },
    {
        code: 'Delivery',
        slug: 'pharmacy',
    },
    {
        code: 'CompleteAccount',
        slug: 'complete-account',
    },
    {
        code: 'Payment',
        slug: 'payment',
    },
    {
        code: 'Video',
        slug: 'video',
    },
    {
        code: 'Summary',
        slug: 'summary',
    },
    {
        code: 'Medical-History',
        slug: 'medical-history',
    },
];
//# sourceMappingURL=constants.js.map